import { FileUploadSetting } from 'backend';
import { putUploadFile, validateUploadFile } from 'fetcher';
import { FileUploadProperty } from 'shared';
import { FileUploadSessionStateReady } from 'store';
import { handleError } from './handleError';
import {
  FileUploadResult,
  FILE_UPLOAD_RESULT_TYPE,
  getThumbnail,
} from './models';
import { validationFile } from './validationFile';

export type UploadAndVerifyPayload = {
  file: File;
  session: FileUploadSessionStateReady;
  setting: FileUploadSetting;
  property: FileUploadProperty;
};

export const uploadAndVerify = async ({
  file,
  setting,
  session,
  property,
}: UploadAndVerifyPayload): Promise<FileUploadResult> => {
  const validationResult = validationFile({
    file,
    session,
    fileUploadSetting: setting,
    property,
  });
  if (validationResult.errorMessages.length > 0) {
    return {
      type: FILE_UPLOAD_RESULT_TYPE.failure,
      errorMessages: validationResult.errorMessages,
      errorTypes: validationResult.errorTypes,
    };
  }
  const { subjectId } = property.inputFormat;
  try {
    const {
      mediaFileStore,
      accessKeyId,
      secretAccessKey,
      token,
      submissionId,
    } = session.submissionSession;
    await putUploadFile({
      region: mediaFileStore.propertyMap.region,
      bucketName: mediaFileStore.propertyMap.bucketName,
      uploadPath: mediaFileStore.uploadPathMap[subjectId],
      file,
      accessKeyId,
      secretAccessKey,
      token,
    });
    const result = await validateUploadFile({
      apiRoot: setting.submissionApiOrigin,
      subjectId,
      submissionId,
    });
    const thumbnail = await getThumbnail({
      file,
      attributeMap: result.mediaFileMetadata.attributeMap,
    });
    return {
      type: FILE_UPLOAD_RESULT_TYPE.success,
      fileSrn: result.mediaFileMetadata.id,
      thumbnail,
    };
  } catch (e) {
    return handleError(e, setting);
  }
};
